export const sanitizeInput = (input) => {
    // 1. 前後の空白除去
    const trimmed = input.trim();
  
    // 2. 危険な記号を除去（必要なら調整）
    const sanitized = trimmed.replace(/[<>{}[\]"'`$\\]/g, '');
  
    return sanitized;
  };
  